export default __webpack_public_path__ + "static/media/bin-types-photo.3b008cd2.webp";